var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16 2.129-.554-1.13-.41 1.189-2.826 8.178L2.088 15.17 1 15.686l1.12.444 7.59 3.01.37.147-.02.058.058.02 4.94 10.44L15.62 31l.406-1.258 2.614-8.096 10.397-4.941 1.117-.532-1.16-.432-7.723-2.87L16 2.128zm-4.5 17.707 3.938 8.325 2.03-6.286-5.968-2.04zm6.306 1.048.182-.087 9.483-4.507-6.541-2.432-9.512 4.844 6.388 2.183zM3.624 15.6l8.108-3.846-2.145 6.21L3.624 15.6zm7.1 2.281 9.475-4.825-4.586-9.336-4.89 14.161z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNas);
export default __webpack_public_path__ + "static/media/NAS.dd4b0b8ea4617db0020ecb6c884b2431.svg";
export { ForwardRef as ReactComponent };